import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { createColumnHelper } from "@tanstack/react-table"
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient"
import DataTable from "../../../components/dataTable/DataTable"
import { iDespesaCartaoViewDto } from "../dto/despesas_cartoes"

const columnHelper = createColumnHelper<iDespesaCartaoViewDto>()

const defaultColumns = [
    columnHelper.accessor('id_cartao', {
        header: 'Cod. Cartão',
        size: 10,
    }),
    columnHelper.accessor('nome_portador', {
        header: 'Portador',
    }),
    columnHelper.accessor(row => row.id_empresa.nome, {
        header: 'Empresa',
    }),
    columnHelper.accessor(row => row.num_cartao.slice(row.num_cartao.length - 4, row.num_cartao.length), {
        header: 'Num. Cartão',
    }),
    columnHelper.accessor(row => `${row.ativo === 1 ? `Ativo` : `Desativado`}`, {
        header: 'Status',
        size: 30,
    }),
]

const defaultOrder:any = []

function DespesasCartoesPage() {
    const [cartoes, setCartoes] = useState<iDespesaCartaoViewDto[]>([])

    useEffect(() => {
        document.title = "Despesas Cartões | OB PORTUS"

        listarDados()
    }, [])

    async function listarDados() {
        const api = await reqGetNew(ApiEndpoints.despesasCartoes)

        if (api.status === 200) {
            const clientesAux:iDespesaCartaoViewDto[] = api.data
            console.log(api.data)
            setCartoes(clientesAux)
        }
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = cartoes[idx]
        const link = `/despesas/cartao/editar?id=${reg.id_cartao}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = cartoes[idx]
        const link = `/despesas/cartao/editar?id=${reg.id_cartao}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">Despesas Cartões</h1>
                <div className="div-row">
                    <Button onClick={() => {
                        window.location.assign(`/despesas/cartao/cadastrar`)
                    }}>Cadastrar</Button>
                </div>
            </div>
            <br></br>
            {<DataTable dados={cartoes} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}
        </div>
    )
}

export default DespesasCartoesPage